export const RESIZE_SUMMARY_TABS = 'resize-summary-tabs';
